import { Component } from '@angular/core';
import { DEFAULT_TOOLTIP_POSITION, DEFAULT_TOOLTIP_THEME, TooltipPosition, TooltipTheme } from './tooltip.enums';

@Component({
  selector: 'tooltip',
  templateUrl: './tooltip.component.html',
  styleUrls: ['./tooltip.component.scss'],
})
export class TooltipComponent {
  position: TooltipPosition = DEFAULT_TOOLTIP_POSITION;
  theme: TooltipTheme = DEFAULT_TOOLTIP_THEME;
  tooltip = '';
  left = 0;
  top = 0;
  visible = false;
}
